<template>
    <li>
        <template v-if="to===undefined">
            {{label}}
        </template>
        <template v-else>
            <a v-bind:href="to">{{label}}</a>
            <i class="fa fa-circle"></i>
        </template>
    </li>
</template>
<script>
export default {
    props:['label','to']
}
</script>
